export const RAMADAN_DATES = {
  1990:{start:'1990-03-27',end:'1990-04-25'},1991:{start:'1991-03-16',end:'1991-04-14'},
  1992:{start:'1992-03-04',end:'1992-04-02'},1993:{start:'1993-02-21',end:'1993-03-23'},
  1994:{start:'1994-02-10',end:'1994-03-12'},1995:{start:'1995-01-31',end:'1995-03-01'},
  1996:{start:'1996-01-20',end:'1996-02-18'},1997:{start:'1997-01-09',end:'1997-02-07'},
  1998:{start:'1997-12-30',end:'1998-01-28'},1999:{start:'1999-12-09',end:'2000-01-07'},
  2000:{start:'2000-11-27',end:'2000-12-26'},2001:{start:'2001-11-16',end:'2001-12-15'},
  2002:{start:'2002-11-05',end:'2002-12-04'},2003:{start:'2003-10-26',end:'2003-11-24'},
  2004:{start:'2004-10-15',end:'2004-11-13'},2005:{start:'2005-10-04',end:'2005-11-02'},
  2006:{start:'2006-09-23',end:'2006-10-22'},2007:{start:'2007-09-13',end:'2007-10-12'},
  2008:{start:'2008-09-01',end:'2008-09-30'},2009:{start:'2009-08-21',end:'2009-09-19'},
  2010:{start:'2010-08-11',end:'2010-09-09'},2011:{start:'2011-08-01',end:'2011-08-29'},
  2012:{start:'2012-07-20',end:'2012-08-18'},2013:{start:'2013-07-08',end:'2013-08-06'},
  2014:{start:'2014-06-28',end:'2014-07-27'},2015:{start:'2015-06-17',end:'2015-07-16'},
  2016:{start:'2016-06-06',end:'2016-07-05'},2017:{start:'2017-05-26',end:'2017-06-24'},
  2018:{start:'2018-05-16',end:'2018-06-14'},2019:{start:'2019-05-05',end:'2019-06-03'},
  2020:{start:'2020-04-23',end:'2020-05-22'},2021:{start:'2021-04-12',end:'2021-05-11'},
  2022:{start:'2022-04-02',end:'2022-05-01'},2023:{start:'2023-03-22',end:'2023-04-20'},
  2024:{start:'2024-03-11',end:'2024-04-09'},2025:{start:'2025-03-01',end:'2025-03-29'},
  2026:{start:'2026-02-18',end:'2026-03-19'},
};